import { Alert, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const NoAudioToast = ({ show }: { show: boolean }): React.ReactElement => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (show) {
      setOpen(true);
    }
  }, [show]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={10000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert severity="info" onClose={() => setOpen(false)}>
        {t("noAudioSlide")}
      </Alert>
    </Snackbar>
  );
};
